<template>
  <div>
    <div class="card card-custom gutter-b">
      <div class="card-header card-header-tabs-line">
        <ul
          class="nav nav-dark nav-bold nav-tabs nav-tabs-line"
          role="tablist"
          ref="builder-tab"
        >
          <li class="nav-item">
            <a
              class="nav-link active"
              data-tab="0"
              data-toggle="tab"
              href="#"
              role="tab"
            >
              Cadastro
            </a>
          </li>
        </ul>
      </div>
      <b-form class="form" @submit.stop.prevent="onSubmit">
        <div class="card-body">
          <b-tabs class="hide-tabs" v-model="tabIndex">
            <b-tab active>
              <b-row>
                <b-col md="2"></b-col>
                <b-col md="8">
                  <b-row>
                    <b-col md="4">
                      <b-form-group
                        id="id_faixa_revenda"
                        label-for="id_faixa_revenda"
                        label="Classificação Revenda"
                      >
                        <b-form-select
                          v-model="$v.form.id_faixa_revenda.$model"
                          :state="validateState('id_faixa_revenda')"
                          class="mb-3"
                        >
                          <b-form-select-option
                            v-for="(faixa, index) in revendas.faixa"
                            :key="'faixa' + index"
                            :value="faixa['ID_FAIXA']"
                          >
                            {{ faixa["DESCRICAO"] }}
                          </b-form-select-option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group
                        id="boleto"
                        label-for="boleto"
                        label="X Parcelado Boleto"
                      >
                        <input
                          type="number"
                          class="form-control"
                          v-model="$v.form.boleto.$model"
                          :state="validateState('boleto')"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group
                        id="cartao_credito"
                        label-for="cartao_credito"
                        label="X Parcelado Cartão Crédito"
                      >
                        <input
                          type="number"
                          class="form-control"
                          v-model="$v.form.cartao_credito.$model"
                          :state="validateState('cartao_credito')"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"></b-col>
                    <b-col md="4">
                      <b-form-group
                        id="qtd_parcelas_juros_boleto"
                        label-for="qtd_parcelas_juros_boleto"
                        label="Parcela para calc. juros"
                      >
                        <input
                          type="number"
                          class="form-control"
                          v-model="form.qtd_parcelas_juros_boleto"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group
                        id="qtd_parcelas_juros_cartao"
                        label-for="qtd_parcelas_juros_cartao"
                        label="Parcela para calc. juros"
                      >
                        <input
                          type="number"
                          class="form-control"
                          v-model="form.qtd_parcelas_juros_cartao"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"></b-col>
                    <b-col md="4">
                      <b-form-group
                        id="juros_boleto"
                        label-for="juros_boleto"
                        label="% Juros Boleto"
                      >
                        <money
                          class="form-control"
                          v-model="form.juros_boleto"
                          v-bind="configMoney"
                        >
                        </money>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group
                        id="juros_cartao_credito"
                        label-for="juros_cartao_credito"
                        label="% Juros Cartão de Crédito"
                      >
                        <money
                          class="form-control"
                          v-model="form.juros_cartao_credito"
                          v-bind="configMoney"
                        >
                        </money>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>
        <div class="card-footer">
          <div class="row">
            <div class="col-lg-12" style="text-align: center">
              <button
                type="submit"
                ref="submit_nova_valor"
                class="btn btn-primary mr-2"
              >
                Salvar
              </button>
              <button
                type="button"
                v-on:click="
                  () => {
                    $router.go(-1);
                  }
                "
                class="btn btn-secondary"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import ProdutosValorData, { ProdutosValorDataRequired } from "./Data";
import ApplicationMixin from "@/modules/Application/mixins/SistemaMixin";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";

export default {
  name: "app-config-renovacoes-valor-form",
  props: {
    url: {
      type: String
    },
    valor: {
      type: Object,
      default: () => {}
    }
  },
  mixins: [validationMixin, ApplicationMixin],
  components: {
    Money
  },
  data() {
    return {
      configMoney: settingMoney,
      tabIndex: 0,
      form: {},
      revendas: {}
    };
  },
  validations: {
    form: ProdutosValorDataRequired
  },
  mounted() {
    this.getDataInit();
  },
  methods: {
    async getRevendas() {
      try {
        const { data } = await this.$http.post("/renovacoes/revendas");
        this.revendas = data;
      } catch {
        return [];
      }
    },
    async getDataInit() {
      this.getRevendas();

      if (this.valor.id) {
        this.form = this.valor;
        this.form.juros_boleto = this.numberToReal(this.form.juros_boleto);
        this.form.juros_cartao_credito = this.numberToReal(
          this.form.juros_cartao_credito
        );
        return;
      }

      this.form = new ProdutosValorData({});
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_nova_valor"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          return;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");

        await this.$http.post(this.url, this.form);

        this.$toast.success("Operação realizada com suceso!");

        this.$router.push({ name: "configuracoesRenovacoesPagamentoLista" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      }
    }
  }
};
</script>

<style>
.vs__dropdown-toggle {
  border: 2px solid #dedede;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 6px;
  outline: none;
  height: 38px;
}
</style>
